export default "/_next/static/videos/about-team-person-1.mp4";